import { useState, useEffect } from 'react';
import { useUpdateEffect } from './useUpdateEffect';
import automobyApi from '../Api';
 
export const useLog = (defaultPageSize) => {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0); 
  const [filter, setFilter] = useState({
    all: true,
    limit: defaultPageSize,
    user_id:0,
    action_id:-1,
    vin:"",
    query:"",
    car_id: null,
    container_id:null,
    cargo_id: null,
    order_by: "id",
    page: 1,
  });

  useUpdateEffect(() => {
    fetchList();
  }, [filter]);
 
  const fetchList = async () => {
    try {
      const response = await automobyApi.post("/log/list", filter)
      setItems(response.data.logs);
      setTotal(response.data.total);
      return response.data.logs
    } catch (error) { 
      console.error("error:" + error);
    }
  }

  const fetch = async () => {
    try {
      const requestData = {
        all: true,
        limit: 100,
        order_by: "id",
        offset: 1
      };

      const response = await automobyApi.post("/log/all", requestData)
      setItems(response.data.logs);
      setTotal(response.data.total);
      return response.data.logs
    } catch (error) {

      console.error("error:" + error);
    }
  }

  const add = async (newData) => {
    try {
      const response = await automobyApi.post(`/log/create`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const search = async (log, count) => {
    try {
      const requestData = {
        log: log,
        count: count,
      };

      const response = await automobyApi.post("/log/search", requestData)
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const update = async (newData) => {
    try {
      const response = await automobyApi.post(`/log/update`, newData);
      fetchList();
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  const remove = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const requestData = {
          log_id: id
        };
        const response = await automobyApi.post(`/log/delete`, requestData);
        fetchList();
        resolve(response);
      } catch (error) {
        reject(error);
      }
    });
  } 

  const updateLocal = async (log) => {
    setItems(items.map(item =>
      item.id === log.id ? log : item
    ));
  }
 

  const logService = {
    items: items,
    total: total,
    filter: filter, 
    setFilter: setFilter,
    fetch: fetch,
    fetchList: fetchList,
    add: add,
    search: search,
    update: update,
    remove: remove, 
  };

  return { logService };
}